import { DeliveryStatus } from "@types_def/models/delivery.types";

export function addRoutes(
  map,
  data: {
    index: number;
    color?: string;
    weight?: number;
    origin: google.maps.LatLngLiteral;
    destination: google.maps.LatLngLiteral;
  }
) {
  const { color = "#00244f", weight = 4, origin, destination, index = 1 } = data;
  const directionsService = new google.maps.DirectionsService();

  // Create a Polyline instead of DirectionsRenderer
  const polyline = new google.maps.Polyline({
    strokeColor: color,
    strokeWeight: weight,
    zIndex: index, // routeIndex equivalent for drawing order
  });

  polyline.setMap(map);

  directionsService.route(
    {
      origin,
      destination,
      travelMode: google.maps.TravelMode.DRIVING,
    },
    (result, status) => {
      if (status === "OK" && result?.routes?.[0]?.overview_path) {
        polyline.setPath(result.routes[0].overview_path);
      }
    }
  );

  // Return the polyline so it can be cleared via polyline.setMap(null) by the caller
  return polyline as unknown as google.maps.DirectionsRenderer;
}

export function isOnGoing(status: DeliveryStatus) {
  return [
    DeliveryStatus.PICKUP_DRIVER,
    DeliveryStatus.ONGOING,
    DeliveryStatus.DELIVERED,
    DeliveryStatus.PICKUP_CLIENT,
    DeliveryStatus.SWAP_PICKUP_DRIVER,
    DeliveryStatus.SWAP_IN_TRANSIT,
    DeliveryStatus.SWAP_PICKUP_CLIENT,
    DeliveryStatus.SWAP_DELIVERED,
  ].includes(status);
}
